<template>
  <div style="padding-bottom: 3rem">
    <div class="m15 bg-white" v-for="item in list" :key="list.title">
      <div class="content">
        <div class="title">{{ item.title }}</div>
        <van-row type="flex" justify="space-start">
          <van-col
            span="8"
            v-permission="el.permission"
            class="item flex flex-column"
            @click="goTo(el.path, el.query)"
            v-for="el in item.content"
            v-if="el.tit !== '授权码生成' || cashierAuthSwitch"
          >
            <div class="item2">
              <van-icon name="gift-o"></van-icon>
              <div class="fs12 gray-8">{{ el.tit }}</div>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Home",
  data() {
    return {
      cashierAuthSwitch: localStorage.getItem("cashierAuthSwitch") === "true",
      list: [
        {
          title: "常用应用",
          content: [
            {
              tit: "采购参数",
              path: "/purchase/config",
              permission: "purchase:config:modify",
            },
            {
              tit: "采购订单",
              path: "/purchase/order",
              permission: "purchase:order:query",
            },
            {
              tit: "采购收货",
              path: "/purchase/receive",
              permission: "purchase:receive:query",
            },
            {
              tit: "采购退货",
              path: "/purchase/return",
              permission: "purchase:return:query",
            },
            {
              tit: "授权码生成",
              path: "/dashboard/auth-code",
              permission: "base-data:product:info:query",
            },
          ],
        },
        {
          title: "基础信息管理",
          content: [
            {
              tit: "供应商信息",
              path: "/product/supplier",
              permission: "base-data:supplier:query",
            },
          ],
        },
        {
          title: "库存管理",
          content: [
            {
              tit: "商品库存",
              path: "/stock/product",
              permission: "stock:product:query",
            },
            {
              tit: "库存变动记录",
              path: "/stock/product/log",
              permission: "stock:product-log:query",
            },
            {
              tit: "商品批次",
              path: "/stock/lot",
              permission: "stock:lot:query",
            },
            {
              tit: "盘点单",
              path: "/stock/inventory",
              permission: "stock:take:sheet:query",
            },
          ],
        },
        {
          title: "商品管理",
          content: [
            {
              tit: "商品档案",
              path: "/product/category",
              permission: "base-data:product:info:query",
              query: { type: "edit" },
            },
            {
              tit: "商品查询",
              query: { type: "search" },
              path: "/product/category",
              permission: "base-data:product:info:query",
            },
            {
              tit: "商品新增",
              path: "/product/add",
              permission: "base-data:product:info:add",
            },
            {
              tit: "商品临期预警",
              path: "/product/advent",
              permission: "base-data:product:warning:query",
            },
            {
              tit: "商品品牌",
              path: "/product/brand",
              permission: "base-data:product:brand:query",
            },
          ],
        },
        {
          title: "零售管理",
          content: [
            {
              tit: "零售参数",
              path: "/retail/config",
              permission: "retail:config:modify",
            },
            {
              tit: "零售出库",
              path: "/retail/out",
              permission: "retail:out:query",
            },
            {
              tit: "零售退货",
              path: "/retail/return",
              permission: "retail:return:query",
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.cashierAuthSwitch =
      localStorage.getItem("cashierAuthSwitch") === "true";
  },
  methods: {
    goTo(target, params) {
      this.$router.push({ path: target, query: params });
    },
  },
};
</script>
<style lang="less">
.content {
  padding: 15px 15px 5px;
  .title {
    padding: 5px 0;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  .item {
    margin-bottom: 20px;
  }
  .item2 {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    color: #333;
  }
  .van-icon {
    font-size: 20px;
    color: #777;
  }
}
</style>
